export const HUBSPOT_PORTAL_ID = "241966500";
export const HUBSPOT_REGION = "na2";

export const getHubSpotDeveloperScriptSrc = (
  portalId: string = HUBSPOT_PORTAL_ID,
  region: string = HUBSPOT_REGION
) => `https://js-${region}.hsforms.net/forms/embed/developer/${portalId}.js`;

export const getHubSpotEmbedScriptSrc = (portalId: string, region: string) => {
  const host = region === "na1" ? "js.hsforms.net" : `js-${region}.hsforms.net`;
  return `https://${host}/forms/embed/${portalId}.js`;
};

const scriptPromises = new Map<string, Promise<void>>();

const loadScriptOnce = (src: string): Promise<void> => {
  const cached = scriptPromises.get(src);
  if (cached) {
    return cached;
  }

  const promise = new Promise<void>((resolve, reject) => {
    if (typeof document === "undefined") {
      resolve();
      return;
    }

    const existingScript = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`);
    if (existingScript) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    script.dataset.hubspotEmbed = "true";
    script.addEventListener("load", () => resolve(), { once: true });
    script.addEventListener("error", () => reject(new Error(`Failed to load HubSpot script: ${src}`)), { once: true });
    document.body.appendChild(script);
  });

  scriptPromises.set(src, promise);
  return promise;
};

export const ensureHubSpotDeveloperScript = (
  portalId: string = HUBSPOT_PORTAL_ID,
  region: string = HUBSPOT_REGION
) => loadScriptOnce(getHubSpotDeveloperScriptSrc(portalId, region));

export const ensureHubSpotEmbedScript = (portalId: string, region: string) =>
  loadScriptOnce(getHubSpotEmbedScriptSrc(portalId, region));

export const resetHubSpotFormElement = (element: HTMLElement) => {
  element.innerHTML = "";
  delete element.dataset.fetched;
  delete element.dataset.loaded;
  element.removeAttribute("id");
};

/**
 * HubSpot の MutationObserver が拾い損ねた場合に、要素の差し替えで初期化を再トリガーする。
 */
export const ensureHubSpotFormElementInit = (element: HTMLElement): HTMLElement => {
  if (element.dataset.fetched || element.childElementCount > 0) {
    return element;
  }

  const parent = element.parentElement;
  if (!parent) {
    return element;
  }

  const replacement = element.cloneNode(true) as HTMLElement;
  parent.replaceChild(replacement, element);
  return replacement;
};
